// extracted by mini-css-extract-plugin
export default {"wrapper":"Ticker_wrapper__vUD1C","track":"Ticker_track__K0-W5","ticker":"Ticker_ticker__cFXZV","highlight":"Ticker_highlight__aVtXr","dim":"Ticker_dim__+Knf2"};